import { render, staticRenderFns } from "./price.vue?vue&type=template&id=b3ea2ea4"
import script from "./price.vue?vue&type=script&lang=js"
export * from "./price.vue?vue&type=script&lang=js"
import style0 from "./price.vue?vue&type=style&index=0&id=b3ea2ea4&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3ea2ea4')) {
      api.createRecord('b3ea2ea4', component.options)
    } else {
      api.reload('b3ea2ea4', component.options)
    }
    module.hot.accept("./price.vue?vue&type=template&id=b3ea2ea4", function () {
      api.rerender('b3ea2ea4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/price.vue"
export default component.exports